import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { clearDreamDraft } from "../../utils/dreamDraft";
import styled from "styled-components";
import { Container, Button, Form } from "react-bootstrap";
import axios from "axios";
import { useEffect, useState } from "react";
import { useGoal } from "./GoalContext";
import apiClient from "../Login/apiClient";

import { ToastContainer, toast } from "react-toastify";

const StyledContainer = styled(Container)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  padding-top: 25px;
  padding-bottom: 25px;
  padding-left: 12px;
  padding-right: 12px;
  background-color: #f5f5f5;
  overflow-x: hidden;
`;

const ConfirmForm = styled(Form)`
  width: 100%;
  max-width: 500px;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  background-color: white;
  box-sizing: border-box;
  .form-control[readonly] {
    font-size: 16px;
    cursor: default;
    pointer-events: none;
  }
  .form-control[readonly]:focus {
    box-shadow: none;
  }

  img {
    width: 100%;
    max-width: 320px;
    height: auto;
    aspect-ratio: 1 / 1;
    object-fit: cover;
    border-radius: 10px;
    display: block;
    margin: 0 auto;
  }

  @media (max-width: 768px) {
    width: 90%; // 繧ｹ繝槭・縺ｧ縺ｯ逕ｻ髱｢縺ｫ蜿弱∪繧九し繧､繧ｺ
    padding: 20px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
  }
`;

const ConfirmButton = styled(Button)`
  width: 45%;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const StyledButton = styled.button`
  padding: 10px 20px; /* 荳贋ｸ・0px縲∝ｷｦ蜿ｳ15px縺ｮ蜀・Κ繝代ョ繧｣繝ｳ繧ｰ繧定ｨｭ螳・*/
  border: none; /* 繝懊・繝繝ｼ繧呈ｶ医☆ */
  color: ${(props) => (props.selected ? "white" : "white")};
  background-color: ${(props) => (props.selected ? "#7d7d7d" : "#7d7d7d")};
  cursor: not-allowed;
  font-size: 12px; /* 繝輔か繝ｳ繝医し繧､繧ｺ繧定ｨｭ螳・*/
  border-radius: 5px; /* 隗偵ｒ荳ｸ縺上☆繧・*/
  margin-left: 3px;
  margin-bottom: 5px;
  text-align: center; /* 繝・く繧ｹ繝医ｒ荳ｭ螟ｮ謠・∴縺ｫ縺吶ｋ */
  align-items: center; /* 蝙ら峩譁ｹ蜷代・荳ｭ螟ｮ謠・∴ */
  justify-content: center; /* 豌ｴ蟷ｳ譁ｹ蜷代・荳ｭ螟ｮ謠・∴ */
  display: flex;

  ${(props) =>
    props.selected &&
    `
    color: white;
    background-color: #267ca7;
  `}

  &:disabled {
    cursor: not-allowed;
    background-color: #ccc; /* 辟｡蜉ｹ蛹匁凾縺ｮ繧ｹ繧ｿ繧､繝ｫ */
  }

  @media (max-width: 768px) {
    font-size: 10px; // 繝輔か繝ｳ繝医ｒ蟆上＆縺・
    padding: 8px 12px; // 繝代ョ繧｣繝ｳ繧ｰ繧りｪｿ謨ｴ
  }
`;

const SpacedTagsFormGroup = styled(Form.Group)`
  display: flex; /* Flexbox 繧呈怏蜉ｹ縺ｫ縺吶ｋ */
  flex-wrap: wrap; /* 繧ｳ繝ｳ繝・Φ繝・′繧ｳ繝ｳ繝・リ縺ｮ蟷・ｒ雜・∴縺溷ｴ蜷医↓謚倥ｊ霑斐☆ */
  align-items: center; /* 繧｢繧､繝・Β繧貞桙逶ｴ譁ｹ蜷代・荳ｭ螟ｮ縺ｫ驟咲ｽｮ */
  justify-content: flex-start; /* 繧｢繧､繝・Β繧呈ｰｴ蟷ｳ譁ｹ蜷代・髢句ｧ狗ｫｯ縺ｫ驟咲ｽｮ */
  gap: 8px; /* 繝懊ち繝ｳ髢薙・髫咎俣繧定ｨｭ螳・*/
  margin-bottom: 15px;
`;

const StyledTextarea = styled(Form.Control)`
  width: 100%;
  max-width: 100%;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  height: 500px; /* Register.js 縺ｨ蜷後§鬮倥＆ */
  resize: none;
  box-sizing: border-box;
  background-color: white;
  white-space: normal; /* pre-wrap 竊・normal 縺ｫ螟画峩 */
  overflow-wrap: anywhere; /* 蠑ｷ蛻ｶ逧・↓謚倥ｊ霑斐☆ */
  word-break: break-word; /* 蜊倩ｪ槭・騾比ｸｭ縺ｧ繧よ釜繧願ｿ斐＠ */

  @media (max-width: 768px) {
    width: 100%; // 繧ｹ繝槭・縺ｧ縺ｯ逕ｻ髱｢縺ｫ蜿弱∪繧九し繧､繧ｺ
  }
`;

const TagButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const ChipsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;
const ChipReadOnly = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  color: #0072bc;
  background-color: #d5e5f2;
  font-size: 12px;
  border-radius: 5px;
`;

const ConfirmPage = (props) => {
  const [title, setTitle] = useState("");
  const [deadline, setDeadline] = useState("");
  const [category, setCategory] = useState("");
  // const [tags, setTags] = useState("");
  const [tags, setTags] = useState([]);
  const [description, setDescription] = useState("");
  const [image_url, setImage_url] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const { eventDetails } = location.state;

  const selectedTags = eventDetails?.["タグ"]?.split(", ") || [];

  useEffect(() => {
    if (eventDetails) {
      setTitle(eventDetails["無謀な夢"] || "");
      setDeadline(eventDetails["目標実現日"] || "");
      setImage_url(eventDetails["目標イメージ画像"] || "");
      setCategory(categoryMap[eventDetails["カテゴリ"] || ""]);
      setTags(selectedTags);
      setDescription(eventDetails["無謀な夢の詳細"] || "");
    }
  }, [eventDetails]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { setGoalID } = useGoal();

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const tokens = JSON.parse(localStorage.getItem("ResponseData") || "{}");
  const token = tokens?.access || "";

  const categoryMap = {
    "スポーツ": "sports",
    "会社": "company",
    "起業": "entrepreneurship",
    "職業・キャリア": "career",
    "恋愛": "romance",
    "資格・勉強": "study",
    "自己満足": "self_satisfaction",
    "漫画、文学": "literature",
  };

  const handleRegister = async (event) => {
    event.preventDefault();
    if (submitting) return;
    setSubmitting(true);

    // 騾∽ｿ｡蜑阪け繝ｪ繝ｼ繝九Φ繧ｰ・嗾rim・城㍾隍・勁蜴ｻ・乗怙螟ｧ10蛟・
    const cleanedTags = [];
    const seen = new Set();

    for (const raw of tags || []) {
      const t = String(raw || "").trim();
      if (!t) continue;
      const key = t.toLowerCase();
      if (seen.has(key)) continue;
      seen.add(key);
      cleanedTags.push(t);
      if (cleanedTags.length > 10) break;
    }

    if (!title || !deadline || !category || !image_url) {
      toast.info("必須項目を確認してください。");
      return;
    }

    console.log("has token?", !!token);
    console.log("Authorization header", `Bearer ${String(token).slice(0, 12)}...`);

    try {
      const response = await apiClient.post(
        `${API_BASE_URL}/api/goals/`,
        { title: title, deadline: deadline, category: category, tags: cleanedTags, description: description, image_url: image_url }
        // {
        //   headers: { Authorization: `Bearer ${token}` },
        // }
      );
      console.log(response.data.id);
      clearDreamDraft();
      setGoalID(response.data.id);
      navigate("/RegisterCompleteView");
    } catch (error) {
      console.error(error);
      const data = error?.response?.data;
      const detail = data ? (typeof data === "string" ? data : JSON.stringify(data, null, 2)) : String(error?.message || "unknown error");
      const errorCode = error?.response?.status;
      if (errorCode === 401) {
        toast.warn("認証情報を確認してください。いったんログインし直すと直ることがあります。");
      } else if (errorCode === 400) {
        toast.info(`入力エラー:\n${detail}`);
      } else if (errorCode === 500) {
        toast.error(`サーバーエラー(500):\n${detail}`);
      } else {
        toast.error(`予期せぬエラー:\n${detail}`);
      }
      setSubmitting(false);
    }
  };

  return (
    <StyledContainer>
      <ConfirmForm onSubmit={handleRegister}>
        <Form.Group>
          <Form.Label>
            無謀な夢 <span className="badge bg-danger">必須</span>
          </Form.Label>
          <Form.Control readOnly defaultValue={eventDetails["無謀な夢"]} style={{ backgroundColor: "#e9ecef", color: "#6c757d", cursor: "not-allowed" }} />
        </Form.Group>
        <br />
        <Form.Group>
          <Form.Label>
            目標実現日 <span className="badge bg-danger">必須</span>
          </Form.Label>
          <Form.Control readOnly defaultValue={eventDetails["目標実現日"]} style={{ backgroundColor: "#e9ecef", color: "#6c757d", cursor: "not-allowed" }} />
        </Form.Group>
        <br />
        <Form.Group>
          <Form.Label>
            カテゴリ <span className="badge bg-danger">必須</span>
          </Form.Label>
          <Form.Control readOnly defaultValue={eventDetails["カテゴリ"]} style={{ backgroundColor: "#e9ecef", color: "#6c757d", cursor: "not-allowed" }} />
        </Form.Group>
        <br />
        <Form.Group>
          <Form.Label>
            目標イメージ画像 <span className="badge bg-danger">必須</span>
          </Form.Label>
          <br />
          {eventDetails["目標イメージ画像"] ? (
            <img
              src={eventDetails["目標イメージ画像"]}
              alt="goal-preview"
              style={{ width: "100%", maxWidth: "320px", height: "auto", aspectRatio: "1 / 1", objectFit: "cover", borderRadius: "10px", display: "block", margin: "0 auto" }}
            />
          ) : (
            <Form.Control readOnly defaultValue="画像が選択されていません" />
          )}
        </Form.Group>
        <br />
        <Form.Group>
          <Form.Label>
            タグ <span className="badge bg-secondary">任意</span>
          </Form.Label>
          <ChipsRow>{tags.length === 0 ? <span style={{ color: "#6c757d" }}>タグは設定されていません</span> : tags.map((t, i) => <ChipReadOnly key={`${t}-${i}`}>#{t}</ChipReadOnly>)}</ChipsRow>{" "}
        </Form.Group>
        {/* 無謀な夢の詳細表示 */}
        <br />
        <Form.Group>
          <Form.Label>
            無謀な夢の詳細 <span className="badge bg-danger">必須</span>
          </Form.Label>
          <StyledTextarea as="textarea" readOnly defaultValue={eventDetails["無謀な夢の詳細"]} style={{ backgroundColor: "#e9ecef", color: "#6c757d", cursor: "not-allowed" }} />
        </Form.Group>

        <h1> </h1>
        <ButtonContainer>
          <ConfirmButton variant="contained" size="lg" block onClick={() => navigate("/Register", { state: { eventDetails } })} className="w-90 text-center d-flex align-items-center justify-content-center" style={{ minWidth: "80px", whiteSpace: "nowrap", fontSize: "1.2rem", backgroundColor: "#282c34", color: "#ffffff", borderColor: "#282c34" }}>
            戻る
          </ConfirmButton>
          <ConfirmButton type="submit" variant="primary" size="lg" block disabled={submitting} className="w-90 text-center d-flex align-items-center justify-content-center" style={{ minWidth: "80px", whiteSpace: "nowrap", fontSize: "1.2rem", backgroundColor: submitting ? "#999" : "#282c34", color: "#ffffff", borderColor: submitting ? "#999" : "#282c34" }}>
            {submitting ? "投稿中..." : "投稿する"}
          </ConfirmButton>
        </ButtonContainer>
      </ConfirmForm>
      <ToastContainer position="top-center" autoClose={3000} />
    </StyledContainer>
  );
};

export default ConfirmPage;
